import type * as React from "react";
interface LegacyDataTableFooterProps {
    className?: string;
    children?: React.ReactNode;
}
export function LegacyDataTableFooter({ className, children }: LegacyDataTableFooterProps): React.ReactElement {
    return <tfoot className={className}>{children}</tfoot>;
}
